import { render, staticRenderFns } from "./UserInstitutionList.vue?vue&type=template&id=4641fc6c&"
import script from "./UserInstitutionList.vue?vue&type=script&lang=js&"
export * from "./UserInstitutionList.vue?vue&type=script&lang=js&"
import style0 from "./UserInstitutionList.vue?vue&type=style&index=0&id=4641fc6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports